module.exports = __webpack_public_path__ + "media/images/default/shared/header/logo-color-5a5bad47485e0ad645ccdb0ec4f99f06.jpg";